import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=44dd655e&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=44dd655e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd655e",
  null
  
)

export default component.exports